export const env = process.env.NODE_ENV || "development";
export const dev = env === "development";
export const apiBaseUrl = dev ? "https://booking.verkehrsschule.ch" : "";